__turbopack_context__.v({
  "bottomFooter": "bottom-footer-module__SF9zfW__bottomFooter",
  "bottomFooter-right": "bottom-footer-module__SF9zfW__bottomFooter-right",
  "brandmarkIcon": "bottom-footer-module__SF9zfW__brandmarkIcon",
  "brandmarkIcon1": "bottom-footer-module__SF9zfW__brandmarkIcon1",
  "brandmarkIcon2": "bottom-footer-module__SF9zfW__brandmarkIcon2",
  "container": "bottom-footer-module__SF9zfW__container",
  "footerBranding": "bottom-footer-module__SF9zfW__footerBranding",
  "footerMessage": "bottom-footer-module__SF9zfW__footerMessage",
  "legalInfo": "bottom-footer-module__SF9zfW__legalInfo",
  "message": "bottom-footer-module__SF9zfW__message",
  "message1": "bottom-footer-module__SF9zfW__message1",
});
